import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
import dayjs from "dayjs";
import Icon from "../icon/Icon";
import { CashUsed, PointCanceled, PointEarn, Sizes } from "../icon/IconList";
const PointTransactionItem = (param)=>{
    let { transaction  } = param;
    const { orderTitle , status , totalAmount , firstCreatedAt , expiredAt , pointBenefitUserId , membershipTitle  } = transaction;
    const displayIcon = ()=>{
        switch(status){
            case "EARN":
            case "RESTORE":
                return PointEarn;
            case "USE":
                return CashUsed;
            default:
                return PointCanceled;
        }
    };
    const displayStatusText = ()=>{
        switch(status){
            case "EARN":
                return pointBenefitUserId ? "포인트 혜택 적립" : "포인트 주문 적립";
            case "USE":
                return "상품 결제";
            case "EXPIRE":
                return "포인트 만료";
            case "RESTORE":
                return "상품 결제 취소";
            case "REFUND":
                return "포인트 주문 적립 취소";
        }
    };
    const displayAmountText = ()=>{
        switch(status){
            case "EARN":
            case "RESTORE":
                return "+".concat(totalAmount.toLocaleString(), "원");
            case "REFUND":
            case "EXPIRE":
            case "USE":
                return "".concat(totalAmount.toLocaleString(), "원");
        }
    };
    const displayAmountColor = ()=>{
        switch(status){
            case "EARN":
            case "RESTORE":
                return "text-mint-400";
            default:
                return "text-primary";
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-3 border-b border-gray-100 p-4",
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                icon: displayIcon(),
                size: Sizes.large
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subtitle1",
                                        className: "text-primary",
                                        children: displayStatusText()
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subtitle1",
                                        className: displayAmountColor(),
                                        children: displayAmountText()
                                    })
                                ]
                            }),
                            orderTitle && /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-primary",
                                children: status === "EARN" && pointBenefitUserId ? "혜택 : ".concat(membershipTitle) : orderTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsxs(Typography, {
                            variant: "body2",
                            className: "text-secondary",
                            children: [
                                dayjs(firstCreatedAt).format("YYYY.MM.DD HH:mm"),
                                " ",
                                status === "EARN" && "(".concat(dayjs(expiredAt).format("YYYY.MM.DD HH:mm"), " 소멸 예정)")
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
export default PointTransactionItem;
